import { render } from "./PledgeManagerInfoComparison.vue?vue&type=template&id=0fba3250"
import script from "./PledgeManagerInfoComparison.vue?vue&type=script&lang=js"
export * from "./PledgeManagerInfoComparison.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__